import React from "react";
import { WalletOutlined } from "@ant-design/icons";
import { formatMoney } from "../../utils/formatUtils";
import { getCurrencyTheme } from "../../utils/themeUtils";

export function WalletCard({
  currency,
  walletBalance,
  totalBalance,
  accountCount,
  active = false,
  onClick,
}) {
  const theme = getCurrencyTheme(currency);

  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "group relative shrink-0 overflow-hidden rounded-2xl border text-left transition-all duration-200",
        "hover:-translate-y-0.5 hover:shadow-xl",
        active ? "ring-4 ring-offset-4 shadow-lg" : "shadow-sm",
        "w-[388.8px] h-[244.8px]",
      ].join(" ")}
      style={{
        backgroundColor: theme.bg,
        borderColor: theme.border,
        color: theme.text,
        ringColor: theme.accent,
      }}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-20"
        style={{
          background:
            "radial-gradient(circle at top right, rgba(255,255,255,0.9), transparent 32%), radial-gradient(circle at bottom left, rgba(255,255,255,0.55), transparent 28%)",
        }}
      />

      <div className="relative flex h-full flex-col p-5">
        <div className="mb-4 flex items-start justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            <div
              className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-white"
              style={{ backgroundColor: theme.iconBg }}
            >
              <WalletOutlined className="text-[18px]" />
            </div>

            <div className="min-w-0">
              <div
                className="text-[10px] font-medium uppercase tracking-[0.28em]"
                style={{ color: theme.muted }}
              >
                Валютын үлдэгдэл
              </div>
              <div className="mt-1 truncate text-[32px] font-bold leading-none">
                {currency}
              </div>
            </div>
          </div>

          <div
            className="rounded-full border px-3 py-1 text-[12px] font-semibold"
            style={{
              borderColor: "rgba(17,17,17,0.45)",
              backgroundColor: "rgba(255,255,255,0.55)",
              color: theme.text,
            }}
          >
            {currency}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-5 gap-y-4">
          <div className="min-w-0">
            <div
              className="mb-1 text-[10px] uppercase tracking-[0.16em]"
              style={{ color: theme.muted }}
            >
              Хийсвэр үлдэгдэл
            </div>
            <div className="min-w-0 break-all text-[16px] font-semibold leading-tight">
              {formatMoney(walletBalance ?? 0, currency)}
              {/* 6423663636362346262623623623626 */}
            </div>
          </div>

          <div className="min-w-0">
            <div
              className="mb-1 text-[10px] uppercase tracking-[0.16em]"
              style={{ color: theme.muted }}
            >
              Жинхэнэ үлдэгдэл
            </div>
            <div className="min-w-0 break-all text-[16px] font-semibold leading-tight">
              {formatMoney(totalBalance ?? 0, currency)}
            </div>
          </div>

          <div className="min-w-0">
            <div
              className="mb-1 text-[10px] uppercase tracking-[0.16em]"
              style={{ color: theme.muted }}
            >
              Дансны тоо
            </div>
            <div className="text-[15px] font-semibold leading-tight">
              {accountCount ?? 0}
            </div>
          </div>

          <div className="flex items-end justify-end">
            <span
              className="block h-2 w-16 rounded-full"
              style={{ backgroundColor: theme.accent }}
            />
          </div>
        </div>

        <div className="mt-auto flex items-end justify-between border-t border-black/10 pt-3">
          {/* <span
            className="text-[11px] font-medium uppercase tracking-[0.18em]"
            style={{ color: theme.muted }}
          >
            Данс харахаар дарна уу
          </span> */}

          {active ? (
            <span className="text-[11px] font-semibold uppercase tracking-[0.12em]">
              Сонгогдсон
            </span>
          ) : null}
        </div>
      </div>
    </button>
  );
}

export default WalletCard;